import { Pipe, PipeTransform } from '@angular/core';
import { CalendarService } from '../services/calendar.service';

@Pipe({
  name: 'calendarFilter'
})
export class CalendarFilterPipe implements PipeTransform {

  constructor(private calendarSvc: CalendarService) { }

  transform(serviceDates: any[], searchFilter: string): any[] {

   // console.log(searchFilter, serviceDates);
    if (searchFilter === undefined || searchFilter === "") {
      return this.resetResults(serviceDates);
     }

    searchFilter = searchFilter.toLowerCase();

    var results = serviceDates.filter((serviceDate) => {
      var matches = serviceDate.AvailableSearchTerms.filter((s) => {
        return (s.toLowerCase().indexOf(searchFilter) > -1)
      });

      return matches.length > 0;
    });

    return this.resetResults(results);

  }

  private resetResults(results: any[]): any[] {
    this.calendarSvc.numberOfRecordsInFilter = results.length;
    this.calendarSvc.numberOfRecordsChanged.emit();
    return results;
  }

}
